import * as React from 'react';
import {
  ActionButton,
  addRowToPayload,
  fetchApi,
  getInitialValuesExistingRow,
  makeCompoundPayload,
  notifyError,
  notifyResponse,
  useCacheRecord,
} from 'gossamer-front-end';
import { InstitutionMember, InstitutionMemberRow, InstitutionMemberView, UserView } from 'cb-model';

export interface MemberRevokeMembershipButtonProps {
  value: string;
}

export const MemberRevokeMembershipButton = (props: MemberRevokeMembershipButtonProps): React.JSX.Element | null => {
  const { data, error } = useCacheRecord<InstitutionMemberRow>(InstitutionMember, props.value);
  if (!!error) {
    notifyError(error, 'An error occurred while fetching the member data');
    return null;
  }
  return (
    <ActionButton
      label="Revoke Membership"
      size="sm"
      variant="danger"
      waiting={!data}
      execute={async (resetCache) => {
        try {
          const payload = makeCompoundPayload('save');
          const row = getInitialValuesExistingRow(InstitutionMember, data);
          row.is_verified = false;
          addRowToPayload(payload, InstitutionMember, row);
          const response = await fetchApi('POST', `/main/institution-member-update-multi`, payload);
          resetCache(InstitutionMember.id, props.value);
          resetCache(InstitutionMemberView.id);
          resetCache(UserView.id, data.user_id);
          notifyResponse(response);
        } catch (e) {
          notifyError(e, 'An error occurred while revoking membership');
        }
      }}
    />
  );
};
